module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAACCAYAAACpDacGAAAAAXNSR0IArs4c6QAAAB5JREFUCB1jdHNz+8+AA+zatYsRJkUNdUwww+hBAwCZqgnVq0+DEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Average.png
// module id = 294
// module chunks = 7